import { useCallback } from 'react';
import { Card, Layout, Row } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  NotificationsRender,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { TCredentials } from 'app/railways/domains/sign-in/core';
import { useSignIn } from 'app/railways/domains/sign-in/features';
import { Loading } from 'app/ui';

import { LoginForm } from '../features/login-form';

const { Content } = Layout;

const Title = <div style={{ textAlign: 'center' }}>Вход в личный кабинет</div>;

export const LoginPage = observer(() => {
  const errorNotify = useNotifyFactory({ behaviour: 'replace_msg' });
  const signInResource = useSignIn({
    errorNotify,
    onSuccess: () => {
      window.location.reload();
    },
  });

  const submitForm = useCallback(
    (credentials: TCredentials) => {
      signInResource.send(credentials);
    },
    [signInResource]
  );

  return (
    <Layout>
      <Content>
        <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
          <Card title={Title} hoverable>
            <Loading active={signInResource.isLoading}>
              <NotificationsRender notifyStore={errorNotify} />

              <LoginForm onSubmit={submitForm} />
            </Loading>
          </Card>
        </Row>
      </Content>
    </Layout>
  );
});
